import styled from 'styled-components';
import { mediaBreakpointDown, mediaBreakpointUp } from '../../styles/grid';
import { MODAL_SIZES } from './constants';

const modalWidthLarge = '1024px';
const modalWidthMedium = '598px';
const modalWidthSmall = '400px';

const modalDesktopBreakpoint = mediaBreakpointUp.md;
const modalMobileBreakpoint = mediaBreakpointDown.sm;
const modalZIndex = 10;

export const ModalOverlay = styled.div`
  position: fixed;
  z-index: ${modalZIndex};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(242, 241, 241, 0.9);
  overflow-y: auto;
`;

export const ModalDialog = styled.div<{ size: MODAL_SIZES }>`
  ${modalMobileBreakpoint} {
    padding: 35px 20px;
  }
  ${modalDesktopBreakpoint} {
    padding: 20px 0;
    margin: auto;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  max-width: ${({ size }) => {
    switch (size) {
      case MODAL_SIZES.sm:
        return modalWidthSmall;
      case MODAL_SIZES.lg:
        return modalWidthLarge;
      default:
        return modalWidthMedium;
    }
  }};
`;

export const ModalContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  outline: none;
`;

export const Body = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  background: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
`;
